export default {
  mobile: "468"
};